<template>
  <div class="ship">
    <div class="ship-title">
      <em class="color-block__back"></em>
      <em class="color-block__orange"></em>
      <span>同公司船舶</span>
      <img src="@/assets/img/company/brand/brand-title.png" alt="" />
    </div>
    <ul class="ship-content">
      <li v-for="(item, nn) in company_cruise" :key="nn">
        <nuxt-link :to="`/company/cruise/${item.id}`">
          <el-image class="ship-img" :src="item.cover" fit="cover" >
              <div slot="error" class="image-slot">
                 <img src="@/assets/img/company/brand-placeholder1.png" />
                 <span>加载失败</span>
              </div>
              <div slot="placeholder" class="image-slot">
                <img src="@/assets/img/company/brand-placeholder1.png" />
                <span>加载中</span>
              </div>
          </el-image>
          <div class="ship-content-title">{{ item.name }}</div>
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
  props: {
    company_cruise: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
  mounted() {
    console.log(this.company_cruise);
  },
});
</script>

<style lang="scss" scoped>
.ship {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  padding: 1rem;
  width: 281px;
}
.ship-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  font-weight: 500;
  padding-top: 7px;
  padding-bottom: 15px;
  position: relative;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  width: 100%;
}
.ship-title .color-block__back {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  height: 14px;
  position: absolute;
  left: 0px;
  top: 6px;
  width: 7px;
  z-index: 2;
}
.ship-title .color-block__orange {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 91, 59, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  height: 16px;
  position: absolute;
  left: 3px;
  bottom: 15px;
  width: 10px;
  z-index: 1;
}
.ship-title span {
  margin-left: 1.25rem;
  margin-top: -4px;
}
.ship-title img {
  height: 19px;
  margin-left: -10px;
  margin-top: -7px;
  width: 19px;
}
.ship-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  width: 100%;
}
.ship-content li {
  margin-bottom: 1rem;
  position: relative;
  width: 100%;
  font-size: 0;
}
.ship-content li .el-image {
  height: 163px;
  width: 100%;
  border-radius: 2px;
}
.ship-content li .ship-content-title {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 500;
  padding-left: 18px;
  padding-top: 17px;
  padding-bottom: 17px;
  position: absolute;
  left: 0px;
  bottom: 0px;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
  z-index: 10;
  font-size: 15px;
  background: linear-gradient(360deg, rgba(0, 0, 0, 0.6) 0%, rgba(217, 217, 217, 0) 143.33%);
}
.ship-content li .ship-content-title:hover {
  --tw-text-opacity: 1;
  color: rgba(242, 91, 59, var(--tw-text-opacity));
}
.ship-content li:last-child {
  margin-bottom: 0px;
}
.image-slot {
  background: url("@/assets/img/company/brand-placeholder.png") no-repeat center center;
  background-size: 100% 100%;
  font-size: 13px;
  font-weight: 500;
  height: 163px;
  padding-top: 20px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
}
.image-slot img {
  margin: auto;
}
.image-slot span {
  display: inline-block;
  margin-top: 14px;
  text-align: center;
}
</style>
